import { Button, Divider, Heading, Modal, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { useConsumerSizes } from '../../utils/responsive'
import { UseCancelAgreementLogicReturn } from './hooks'

interface CancelAgreementModalProps {
  isModalOpen: boolean
  closeModal: () => void
  merchantName: string
  agreementId: number
  useCancelAgreementLogic: (UseCancelAgreementLogicProps) => UseCancelAgreementLogicReturn
}

export const CancelAgreementModal: FunctionComponent<CancelAgreementModalProps> = ({
  isModalOpen = false,
  closeModal,
  merchantName,
  agreementId,
  useCancelAgreementLogic,
}) => {
  const I18N_NAMESPACE = ['common', 'recurringPayments', 'orders']
  const { t } = useTranslation(I18N_NAMESPACE)
  const { sectionHeadingSize, textSize } = useConsumerSizes()
  const { useCancelBillingAgreement } = useCancelAgreementLogic({ agreementId, merchantName, t, closeModal })

  return (
    <Modal show={isModalOpen} onClose={closeModal} testNameSpace='cancel-ba'>
      <Modal.Header>
        <div className='text-center'>
          <Heading size={sectionHeadingSize} testNameSpace='modal'>
            {t('recurringPayments:billingAgreementDetail:cancelModal:header')}
          </Heading>
        </div>
      </Modal.Header>

      <Divider kind={'Hairline'} />
      <Modal.Content>
        <Text testNameSpace='modal-intro' size={textSize}>
          {t('recurringPayments:billingAgreementDetail:cancelModal:intro', { merchantName })}
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <div className='mt-2'>
          <Button testNameSpace='modal-confirm' padding='Fluid' onClick={useCancelBillingAgreement}>
            {t('common:yes')}
          </Button>
        </div>
        <div className='mt-2'>
          <Button.Tertiary testNameSpace='modal-cancel' padding='Fluid' onClick={closeModal}>
            {t('common:no')}
          </Button.Tertiary>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
